// client/src/utils/ownerListingsApi.js — calls to /api/owner-listings with the CLIENT
// PORTAL token (never the staff token), including multipart uploads and private files.
const TOKEN_KEY = 'clientPortalToken';
const token = () => { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } };
export const BASE = '/api/owner-listings';

export async function ownerApi(path, { method = 'GET', body, form } = {}) {
    const headers = { Authorization: `Bearer ${token()}` };
    if (body !== undefined && !form) headers['Content-Type'] = 'application/json';
    const r = await fetch(`${BASE}${path}`, { method, headers, body: form || (body !== undefined ? JSON.stringify(body) : undefined) });
    if (r.status === 401) { window.location.href = `/client-portal/login?next=${encodeURIComponent(window.location.pathname)}`; throw new Error('Please sign in again.'); }
    const j = await r.json().catch(() => ({}));
    if (!r.ok) {
        if (j.mustChangePassword) window.location.href = '/client-portal/change-password';
        const e = new Error(j.message || 'Something went wrong.');
        e.status = r.status; e.problems = j.problems; e.needsVerification = j.needsVerification; e.notOwner = j.notOwner;
        throw e;
    }
    return j;
}

/** A private file (photo / document) as an object URL. */
export async function ownerBlobUrl(path) {
    const r = await fetch(`${BASE}${path}`, { headers: { Authorization: `Bearer ${token()}` } });
    if (!r.ok) throw new Error('Could not load the file.');
    return URL.createObjectURL(await r.blob());
}

export const money = (n) => (n === null || n === undefined || n === '' ? '' : `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 })}`);
export const inputCls = 'mt-1 block w-full rounded-md border border-slate-400 bg-white px-3 py-2 text-slate-900 focus:border-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-600';
export const labelCls = 'block text-sm font-medium text-slate-800';
export const btn = 'rounded-md bg-slate-900 px-4 py-2 font-semibold text-white hover:bg-slate-900 focus:outline-none focus:ring-4 focus:ring-indigo-300 disabled:opacity-60';
export const btn2 = 'rounded-md border border-slate-400 bg-white px-4 py-2 font-semibold text-slate-800 hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-indigo-300 disabled:opacity-60';
export const STATUS_CHIP = {
    draft: 'bg-slate-200 text-slate-800', in_review: 'bg-amber-100 text-amber-900', changes_requested: 'bg-orange-100 text-orange-900',
    approved_pending_agreement: 'bg-sky-100 text-sky-900', live: 'bg-emerald-100 text-emerald-900', paused: 'bg-slate-200 text-slate-800',
    leased: 'bg-indigo-100 text-indigo-900', sold: 'bg-indigo-100 text-indigo-900', rejected: 'bg-red-100 text-red-900',
    expired: 'bg-slate-300 text-slate-900', withdrawn: 'bg-slate-300 text-slate-900',
};
